import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import styles from './SummaryTable.module.scss';
import { useTranslation } from 'react-i18next';
export function DocumentResultsPreparing() {
    const { t } = useTranslation();
    return (_jsx(Box, { className: styles.container, children: _jsx(Typography, { variant: "title", color: "grey.900", children: t('Preparing data...') }) }));
}
